(function () {
	'use strict';

	angular
		.module('as.search', ['list-autocomplete']);
})();
